import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../lib/icons";

/**
 * Shared hours dropdown content — used by Header (desktop + mobile) and Topbar.
 * Displays the weekly schedule, today highlight, vacation banner, and action buttons.
 */
export default function HoursDropdownContent({ s, todayIdx, status, showActions = true }) {
  return (
    <>
      <div className="p-4 bg-[color:var(--brand-navy)] text-white">
        <div className="flex items-center gap-2 text-xs uppercase tracking-wider font-bold mb-1">
          <span className={`w-2 h-2 rounded-full ${status.open ? "bg-emerald-400" : "bg-sky-400"}`} />
          Horaires d'ouverture
        </div>
        <div className="font-display font-bold text-base">{status.label}</div>
      </div>
      <ul className="divide-y divide-[hsl(var(--border))] bg-white">
        {(s.hours || []).map((h, i) => {
          const isToday = i === todayIdx;
          return (
            <li key={i} className={`relative flex items-center justify-between gap-4 px-4 py-2.5 text-sm font-body transition-colors ${isToday ? "bg-sky-50" : ""}`}>
              {isToday && <span className="absolute left-0 top-0 bottom-0 w-1 bg-[color:var(--brand-sky)]" aria-hidden />}
              <span className={`${isToday ? "text-[color:var(--brand-navy)] font-semibold" : "text-[hsl(var(--foreground))] font-medium"}`}>
                {h.day} {isToday && <span className="ml-1 text-[10px] uppercase tracking-wider text-[color:var(--brand-sky)] font-bold">Aujourd'hui</span>}
              </span>
              {h.closed ? (
                <span className="text-xs text-red-600 font-medium">Fermé</span>
              ) : (
                <span className="text-xs text-[hsl(var(--muted-foreground))] font-normal tabular-nums">
                  {h.morning && <span>{h.morning}</span>}
                  {h.morning && h.afternoon && <span className="mx-1.5 opacity-50">·</span>}
                  {h.afternoon && <span>{h.afternoon}</span>}
                </span>
              )}
            </li>
          );
        })}
      </ul>
      {s.vacation?.message && (
        <div className="m-3 p-3 rounded-xl bg-[color:var(--brand-red)]/10 text-[color:var(--brand-red)] text-xs">
          {s.vacation.message}
        </div>
      )}
      {showActions && (
        <div className="p-3 bg-[hsl(var(--muted))]/50 grid grid-cols-2 gap-2">
          {s.phone && (
            <a href={`tel:${s.phone.replace(/\s/g, "")}`} className="flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-[color:var(--brand-red)] text-white font-bold text-xs">
              <Icon name={s.cta_icons?.phone || "Phone"} className="w-3 h-3" /> Appeler
            </a>
          )}
          <Link to="/devis" className="flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-[color:var(--brand-sky)] text-white font-bold text-xs">
            <Icon name={s.cta_icons?.devis || "FileText"} className="w-3 h-3" /> Devis
          </Link>
        </div>
      )}
    </>
  );
}
